<template>
  <v-dialog v-model="visible" persistent max-width="500">
    <v-card class="pa-2">
      <v-card-title class="title">{{title}}</v-card-title>
      <v-card-text>
        <p class="subheading mb-3" v-html="message"></p>

        <v-text-field
          hide-details
          v-if="typeText"
          v-model="confirmTyped"
          outline
          single-line
          label="Type 'confirm' here"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="hide">Cancel</v-btn>
        <v-btn
          :disabled="!checkConfirm"
          :color="confirmBtn.color"
          flat
          @click="confirm"
        >{{confirmBtn.text}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modal from "./";
export default {
  data() {
    return {
      visible: false,
      title: "",
      message: "",
      confirmBtn: {
        color: "primary",
        text: "Confirm"
      },
      typeText: false,
      onConfirm: {},

      confirmTyped: "",
      confirmText: "confirm"
    };
  },
  computed: {
    checkConfirm() {
      if (!this.typeText) return true;
      return this.confirmTyped === this.confirmText;
    }
  },
  methods: {
    hide() {
      this.visible = false;
      this.confirmTyped = "";
    },
    confirm() {
      if (typeof this.onConfirm === "function") {
        this.onConfirm();
        this.hide();
      } else this.hide();
    },
    show(params) {
      this.visible = true;
      this.message = params.message;
      this.typeText = params.typeText;
      this.onConfirm = params.onConfirm;

      if (params.mode === "delete") {
        this.confirmBtn = {
          color: "error",
          text: "Yes, Delete"
        };

        this.title = "Delete";
        return;
      }

      if (params.mode === "confirm") {
        this.confirmBtn = {
          color: "primary",
          text: "Yes, Confirm"
        };

        this.title = "Confirmation";
        return;
      }

      this.title = params.title;
      this.confirmBtn = params.confirmBtn;
    }
  },
  beforeMount() {
    modal.EventBus.$on("show", params => {
      this.show(params);
    });
  }
};
</script>